<script setup lang="ts">
import { Unplug } from 'lucide-vue-next';

import { Button } from '@/components/ui/button';

defineProps<{
    title: string;
    detail: string;
    canRetry: boolean;
}>();

defineEmits<{ retry: [] }>();
</script>

<template>
    <div
        role="alert"
        class="flex max-w-xl flex-col items-center gap-4 text-center"
    >
        <div
            class="flex h-20 w-20 items-center justify-center rounded-full bg-destructive/10 text-destructive"
        >
            <Unplug class="h-10 w-10" aria-hidden="true" />
        </div>
        <div class="space-y-2">
            <h2 class="text-xl font-semibold">{{ title }}</h2>
            <p class="text-sm text-muted-foreground">{{ detail }}</p>
        </div>
        <Button
            v-if="canRetry"
            variant="outline"
            size="sm"
            @click="$emit('retry')"
        >
            Retry
        </Button>
    </div>
</template>
